// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  stringMustBeWithinRange,
  valueIsRequired,
} from 'validators/common/simple'

// required, must be a number and must be min <= x <= max
const requiredStringMustBeWithinRange = (v, min, max) => (
  valueIsRequired(v) || stringMustBeWithinRange(v, min, max)
)

export default requiredStringMustBeWithinRange
